<template>
  <div class="md-layout text-center">
    <div class="md-layout-item md-size-80 md-medium-size-80 md-small-size-90 md-xsmall-size-100">
      <md-card class="privacy-card">
        <md-card-content class="privacy-content">
          <h3 class="main-title">Política de Privacidade — Gerenciador Mobile</h3>
          <p class="update-date">Vigência: 16/10/2025</p>
          <p class="update-date">Última atualização: 16/10/2025</p>

          <h4 class="section-title">1) Quem somos</h4>
          <ul class="data-list">
            <li><strong>Controlador:</strong> CLJ RELACOES INSTITUCIONAIS E GESTAO EMPRESARIAL SCP GESTAO CAP 5.3, CNPJ 40.017.681/0001-15, endereço: AV JOAO CABRAL DE MELLO NETO 850 BLOCO 03 SALA.</li>
            <li><strong>Encarregado de Proteção de Dados (DPO):</strong> Encarregado de Proteção de Dados - CLJ — e-mail: <a href="mailto:adm@cljrelacoesinstitucionais.com.br" class="email-link">adm@cljrelacoesinstitucionais.com.br</a>.</li>
          </ul>
          <p class="text-item">Esta política descreve como tratamos dados pessoais de profissionais da saúde que utilizam o aplicativo e/ou o site do Gerenciador Mobile.</p>

          <h4 class="section-title">2) O serviço</h4>
          <p class="text-item">O Gerenciador Mobile é uma plataforma de captação, gestão e suporte para profissionais da saúde, permitindo anunciar, trocar e se candidatar a plantões, com exibição de hospital, especialidade, data, horário e valor.</p>

          <h4 class="section-title">3) Dados pessoais que coletamos</h4>
          <h5 class="sub-section-title">3.1 Cadastro e perfil</h5>
          <ul class="data-list">
            <li><strong>Credenciais:</strong> e-mail e senha.</li>
            <li><strong>Identificação civil:</strong> nome completo, data de nascimento, gênero, estado civil, nacionalidade, naturalidade, nome da mãe, nome do pai, CPF, RG, órgão expedidor e data de emissão.</li>
            <li><strong>Contato e endereço:</strong> celular, telefone, CEP, rua, número, complemento, município, bairro, comprovante de residência (arquivo).</li>
            <li><strong>Dados profissionais:</strong> profissão, diploma (arquivo), CRM (ou registro profissional equivalente — número e arquivo), UF emissora, ano de formatura, informação sobre residência médica (sim/não), PIS, CNS, experiências anteriores, currículo (arquivo).</li>
          </ul>
          <h5 class="sub-section-title">3.2 Dados bancários (para repasses)</h5>
          <ul class="data-list">
            <li>Banco, agência (com dígito), conta (com dígito), tipo de conta, comprovante bancário (arquivo).</li>
          </ul>
          <h5 class="sub-section-title">3.3 Dados de uso e técnicos</h5>
          <ul class="data-list">
            <li><strong>Registros de acesso:</strong> data/hora, telas e recursos utilizados, cliques.</li>
            <li><strong>Dados do dispositivo:</strong> modelo, sistema operacional, idioma, identificadores do dispositivo/instalação, endereço IP, performance, logs e telemetria.</li>
            <li><strong>Notificações push:</strong> token e preferências (opt-in/opt-out).</li>
          </ul>
          <h5 class="sub-section-title">3.4 Dados de terceiros</h5>
          <ul class="data-list">
            <li><strong>Hospitais/Clínicas/Parceiros:</strong> informações sobre vagas/plantões e status de candidaturas/contratações.</li>
            <li><strong>Órgãos/serviços de verificação profissional e documental,</strong> quando aplicável.</li>
          </ul>
          <p class="text-item"><strong>Observação:</strong> não coletamos dados de saúde de pacientes nem dados sensíveis do usuário (art. 5º, II, LGPD). Caso algum fluxo passe a exigir esse tipo de dado, haverá aviso específico, base legal adequada e coleta de consentimento quando necessário.</p>

          <h4 class="section-title">4) Finalidades e bases legais (LGPD)</h4>
          <ul class="data-list">
            <li><strong>Criar e gerenciar a conta, autenticar login e manter cadastro atualizado.</strong><br>Base: execução de contrato (art. 7º, V) e legítimo interesse para segurança (art. 7º, IX).</li>
            <li><strong>Verificar identidade, qualificação e registros profissionais (ex.: CRM), prevenir fraude e cumprir requisitos legais.</strong><br>Bases: execução de contrato; obrigação legal/regulatória (art. 7º, II); legítimo interesse.</li>
            <li><strong>Intermediar acesso a plantões (exibição de hospital, especialidade, data, hora e valor) e permitir que hospitais visualizem o perfil profissional para seleção.</strong><br>Base: execução de contrato.</li>
            <li><strong>Processar repasses e conciliações financeiras.</strong><br>Bases: execução de contrato; obrigação legal/fiscal.</li>
            <li><strong>Enviar comunicações essenciais (ex.: confirmação de candidatura, alterações de plantão) e prestar suporte.</strong><br>Base: execução de contrato.</li>
            <li><strong>Segurança, prevenção a abusos, monitoramento de performance e melhoria de funcionalidades por meio de analytics.</strong><br>Base: legítimo interesse.</li>
            <li><strong>Cumprir leis, regulamentos e ordens de autoridades.</strong><br>Base: obrigação legal.</li>
          </ul>

          <h4 class="section-title">5) Compartilhamento de dados</h4>
          <ul class="data-list">
            <li><strong>Hospitais/Clínicas/Operadores de plantões:</strong> dados necessários à análise de candidaturas, contratação e operação (acesso ao seu perfil profissional).</li>
            <li><strong>Provedores de infraestrutura e nuvem;</strong> serviços de e-mail/SMS/push; verificação documental/profissional; bancos e meios de pagamento; assessorias jurídicas/auditorias e autoridades públicas quando requerido por lei.</li>
            <li><strong>Operações societárias (fusão/aquisição):</strong> transferência condicionada à manutenção das proteções desta política.</li>
          </ul>
          <p class="text-item">Não vendemos dados pessoais.</p>

          <h4 class="section-title">6) Transferências internacionais</h4>
          <p class="text-item">Segundo informações atuais, não realizamos transferências internacionais de dados. Caso isso mude, adotaremos salvaguardas previstas na LGPD (art. 33 e seguintes) e atualizaremos esta política.</p>

          <h4 class="section-title">7) Retenção e descarte</h4>
          <p class="text-item">Mantemos dados pelo tempo necessário às finalidades desta política e ao cumprimento de obrigações legais/regulatórias, prazos prescricionais e prevenção a fraudes.</p>
          <p class="text-item"><strong>Prazos propostos:</strong></p>
          <ul class="data-list">
            <li><strong>Dados de conta e perfil:</strong> enquanto a conta estiver ativa e por até 5 anos após o término da relação, para defesa de direitos e obrigações legais.</li>
            <li><strong>Documentos de identidade, comprovantes e dados bancários:</strong> pelo período contratual e por até 5 anos após o último repasse/obrigação fiscal.</li>
            <li><strong>Registros de acesso e logs técnicos:</strong> 6 a 12 meses, salvo obrigação legal específica.</li>
            <li><strong>Candidaturas/plantões e histórico operacional/financeiro:</strong> até 5 anos após o término da relação/último evento fiscal.</li>
          </ul>
          <p class="text-item">Ao final dos prazos, dados são eliminados ou anonimizados de forma segura. Observação: “retenção eterna” não é compatível com a LGPD/Google Play; por isso adotamos prazos máximos acima. Caso necessite prazos diferentes, indique-nos para atualização.</p>

          <h4 class="section-title">8) Segurança da informação</h4>
          <p class="text-item">Adoção de medidas técnicas e administrativas proporcionais ao risco: criptografia em trânsito, controles de acesso, segregação de ambientes, gestão de vulnerabilidades, backups, registros de eventos e políticas internas.</p>
          <p class="text-item">Notificaremos incidentes significativos conforme a LGPD e boas práticas.</p>

          <h4 class="section-title">9) Direitos do titular</h4>
          <p class="text-item">Você pode:</p>
          <ul class="data-list">
            <li>Confirmar tratamento e acessar dados; corrigir dados incompletos/inexatos/desatualizados.</li>
            <li>Solicitar anonimização, bloqueio ou eliminação de dados desnecessários ou excessivos.</li>
            <li>Portar dados a outro fornecedor, quando aplicável.</li>
            <li>Solicitar eliminação de dados tratados com consentimento.</li>
            <li>Obter informação sobre compartilhamentos e sobre as consequências da negativa.</li>
            <li>Opor-se a tratamentos baseados em legítimo interesse, quando cabível, e revogar consentimentos.</li>
          </ul>
          <p class="text-item">Como exercer: pelo DPO (<a href="mailto:adm@cljrelacoesinstitucionais.com.br" class="email-link">adm@cljrelacoesinstitucionais.com.br</a>). Podemos solicitar comprovação de identidade.</p>

          <h4 class="section-title">10) Conta, desativação e exclusão</h4>
          <p class="text-item">Você pode solicitar exclusão da conta e dos dados associados. Manteremos somente o mínimo necessário para cumprir obrigações legais, prevenir fraudes e resguardar direitos por prazos prescricionais.</p>
          <p class="text-item">O app oferece meios de exclusão de conta em conformidade com a Política do Google Play (Data Deletion).</p>

          <h4 class="section-title">11) Cookies, SDKs e tecnologias similares</h4>
          <p class="text-item">Utilizamos SDKs/bibliotecas estritamente necessárias à autenticação, notificações, analytics, prevenção a fraudes e performance.</p>
          <p class="text-item">O app permite gerenciar permissões nas configurações do dispositivo. Não realizamos marketing direto.</p>

          <h4 class="section-title">12) Notificações e comunicações</h4>
          <p class="text-item">Comunicações transacionais (ex.: status de candidaturas e plantões) podem ser essenciais ao serviço e não dependem de consentimento.</p>
          <p class="text-item">Não enviamos marketing direto. Não utilizamos WhatsApp para atendimento.</p>

          <h4 class="section-title">13) Decisões automatizadas e perfilamento</h4>
          <p class="text-item">Podemos usar critérios objetivos (ex.: especialidade, disponibilidade, requisitos do hospital, localização do plantão) para ranquear e sugerir oportunidades. Você pode solicitar revisão humana de decisões que afetem seus interesses, quando aplicável.</p>

          <h4 class="section-title">14) Permissões do aplicativo</h4>
          <p class="text-item">Podemos solicitar permissões de armazenamento/arquivos (envio de documentos), câmera (fotografar documentos), notificações e rede, limitadas às finalidades descritas.</p>

          <h4 class="section-title">15) Crianças e adolescentes</h4>
          <p class="text-item">O serviço destina-se a profissionais da saúde maiores de 18 anos. Não coletamos intencionalmente dados de menores.</p>

          <h4 class="section-title">16) Alterações desta política</h4>
          <p class="text-item">Podemos atualizar esta política para refletir mudanças legais ou de produto. Avisaremos por meios adequados e indicaremos a nova data de vigência. O uso continuado após a vigência indica ciência.</p>

          <h4 class="section-title">17) Contato</h4>
          <ul class="data-list">
            <li><strong>Encarregado (DPO):</strong> Encarregado de Proteção de Dados - CLJ — <a href="mailto:adm@cljrelacoesinstitucionais.com.br" class="email-link">adm@cljrelacoesinstitucionais.com.br</a>.</li>
            <li><strong>Endereço postal:</strong> AV JOAO CABRAL DE MELLO NETO 850 BLOCO 03 SALA.</li>
          </ul>
        </md-card-content>
      </md-card>
    </div>
  </div>
</template>

<script>
export default {
  name: "PrivacyPolicy",
  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
.md-layout {
  margin-top: 0;
}

.privacy-card {
  margin: 30px auto;
  background: white;
  box-shadow: none;
  border-radius: 6px;

  .md-card-content {
    padding: 60px 80px !important;
  }
}

.privacy-content {
  text-align: left;
  color: #3c4858;
  line-height: 1.8;

  .main-title {
    font-size: 28px;
    font-weight: 400;
    color: #3c4858;
    margin: 0 0 30px 0;
    text-align: center;
  }

  .intro-text {
    font-size: 16px;
    color: #3c4858;
    line-height: 1.8;
    margin-bottom: 25px;
  }

  .section-title {
    font-size: 18px;
    font-weight: 600;
    color: #3c4858;
    margin: 35px 0 15px 0;
  }

  .text-item {
    font-size: 16px;
    color: #3c4858;
    line-height: 1.8;
    margin-bottom: 15px;
  }

  .email-link {
    color: #0C4DA2;
    text-decoration: none;
    font-weight: 500;

    &:hover {
      text-decoration: underline;
    }
  }

  .data-list {
    list-style: none;
    padding-left: 0;
    margin: 20px 0 30px 0;

    li {
      font-size: 16px;
      color: #3c4858;
      line-height: 2;
      position: relative;
      padding-left: 20px;
      margin-bottom: 10px;

      &:before {
        content: '•';
        position: absolute;
        left: 0;
        color: #0C4DA2;
        font-weight: bold;
      }
    }
  }
  
  .update-date {
    font-style: italic;
    text-align: center;
    margin-top: 40px;
    font-size: 14px;
  }
}

@media (max-width: 768px) {
  .privacy-card {
    margin: 15px auto;

    .md-card-content {
      padding: 40px 30px !important;
    }
  }

  .privacy-content {
    .main-title {
      font-size: 24px;
    }

    .intro-text,
    .text-item,
    .data-list li {
      font-size: 15px;
    }

    .section-title {
      font-size: 17px;
    }
  }
  .sub-section-title {
    font-size: 16px;
    font-weight: 600;
    color: #3c4858;
    margin: 25px 0 10px 0;
  }
}
</style>